export const GLOBAL_TOAST: string = "globalToast"
export const GLOBAL_CONFIRMATION_DELETE = "confirmationDelete";
export const RULE_CONFIRMATION_DELETE = "RuleConfirmationDelete";


